module.exports = __webpack_public_path__ + "static/2-4cedb373ea07962a48d15317c19741a5.png";